import { createContext } from "react";

const confirmApiContext = createContext([{}, function () {}]);

export default confirmApiContext;
